
export enum DeckType {
  LowEntry= 'LowEntry',
  LowFloor= 'LowFloor',
  NormalFloor= 'NormalFloor',

}